import { FunctionComponent, ReactNode } from 'react';
import { useTimeSpentMetric } from '../../hooks';
import { StepKey } from '../../types';
import { isAmazonHost } from '../../utils';
import { environment } from '../../utils/environment';
import {
  ImageContainer,
  StepContent,
  StepContentContainer,
} from './Step.styles';

interface StepProps {
  children: ReactNode;
  image?: ImageData;
  stepKey?: StepKey;
}

export interface ImageData {
  source: string;
  altText: string;
  cssClasses?: string;
}

const Step: FunctionComponent<StepProps> = (props) => {
  const { image, stepKey } = props;
  const { videoSupportEnabled } = environment;

  useTimeSpentMetric(stepKey as string);

  return (
    <div className="row h-100">
      {image && !isAmazonHost() && (
        <ImageContainer
          className={`${
            videoSupportEnabled && stepKey === StepKey.Success
              ? 'col-lg-5 d-none d-lg-flex'
              : 'col-6 col-lg-7 col-xl-8 d-none d-md-flex'
          } p-0 image-container h-100 justify-content-center`}
        >
          <img
            src={image.source}
            alt={image.altText}
            className={`img-fluid align-self-center ${image.cssClasses || ''}`}
          />
        </ImageContainer>
      )}
      <StepContentContainer className="col h-100" id="step-content">
        <StepContent className="row">
          <div className="mt-4 col gx-5">{props.children}</div>
        </StepContent>
      </StepContentContainer>
    </div>
  );
};

export default Step;
